"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCapability = exports.Capabilities = void 0;
const index_1 = require("../types/index");
exports.Capabilities = {
    onboard: index_1.onboardCapabilities,
    edit: index_1.editCapabilities,
    add: index_1.addCapabilities
};
const hasCapability = (mask, capability) => (mask & capability) === capability;
exports.hasCapability = hasCapability;
//# sourceMappingURL=capability.js.map